import GDPRFaceRecognitionConsentModal, {
  GDPR_FACE_RECOGNITION_CONSENT_MODAL,
} from './modal';

export { GDPR_FACE_RECOGNITION_CONSENT_MODAL };

export default GDPRFaceRecognitionConsentModal;
